import React from 'react';
import { EmptyResult } from '@components';
import {
    SHARED_TABLE_EMPTY_STATE_EMPTY_DESCRIPTION,
    SHARED_TABLE_EMPTY_STATE_EMPTY_TITLE,
    SHARED_TABLE_EMPTY_STATE_FILTERED_DESCRIPTION,
    SHARED_TABLE_EMPTY_STATE_FILTERED_TITLE,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___shared___/components/table-empty-state/constants.ts';
import { translateItem } from '@utils/translations.ts';

interface TableEmptyTextProps {
    hasActiveFilters?: boolean;
    emptyTitle?: string;
    emptyDescription?: string;
    emptyTitleWhenFiltered?: string;
    emptyDescWhenFiltered?: string;
}

export const TableEmptyOrFilteredText: React.FC<TableEmptyTextProps> = ({
    emptyTitle,
    emptyDescription,
    emptyTitleWhenFiltered,
    emptyDescWhenFiltered,
    hasActiveFilters = false,
}) => {
    const title = hasActiveFilters
        ? (emptyTitleWhenFiltered ?? translateItem(SHARED_TABLE_EMPTY_STATE_FILTERED_TITLE))
        : (emptyTitle ?? translateItem(SHARED_TABLE_EMPTY_STATE_EMPTY_TITLE));

    const description = hasActiveFilters
        ? (emptyDescWhenFiltered ?? translateItem(SHARED_TABLE_EMPTY_STATE_FILTERED_DESCRIPTION))
        : (emptyDescription ?? translateItem(SHARED_TABLE_EMPTY_STATE_EMPTY_DESCRIPTION));

    return <EmptyResult bgColor="transparent" title={title} description={description} />;
};
